import { IStoryItem, StoryType } from 'interfaces/addStory.interface';
import { ChangeEvent, FC, useState } from 'react';
import {
  MentionInput,
  // MenuCont,
  // MenuItem,
  // MenuItemsCont,
  // Sticker,
} from './StoryLinkMenu.styles';

interface IStoryLinkMenu {
  hideUI: () => void;
  addToStoryBoard?: (data: IStoryItem) => void;
}

const StoryLinkMenu: FC<IStoryLinkMenu> = ({ addToStoryBoard, hideUI }) => {
  // const mentionImg = require('assets/icons/mention.svg');
  // const stickerImg = require('assets/skull-sticker.png');
  // const stickerImg2 = require('assets/appicon.png');

  const [, setShowMentionUsers] = useState<boolean>(false);
  const [link, setLink] = useState<string>('');

  const localAddToStoryBoard = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (addToStoryBoard && e.key === 'Enter') {
      const linkText = link.match(/\.(.*?)\.co/i);
      if (linkText) {
        const data: IStoryItem = {
          id: 0,
          position: {
            X: 50,
            Y: 50,
          },
          size: {
            X: 200,
            Y: 50,
          },
          type: StoryType.Link,
          url: link,
          text: linkText ? linkText[1] : '',
        };
        addToStoryBoard(data);
        hideUI();
      }
    }
  };

  const handleMentionChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 0) {
      setShowMentionUsers(true);
    } else {
      setShowMentionUsers(false);
    }
    setLink(`${e.target.value}`);
  };

  return (
    <MentionInput
      type="text"
      onChange={handleMentionChange}
      autoFocus={true}
      onKeyDown={localAddToStoryBoard}
    />
  );
};

export default StoryLinkMenu;
